// extracted by mini-css-extract-plugin
module.exports = {"loding":"loading_loding__30NaO"};